/**
 * Web mock for react-native-permissions
 * Returns granted on web (no permission system)
 */

const RESULTS = { GRANTED: 'granted', DENIED: 'denied', BLOCKED: 'blocked', UNAVAILABLE: 'unavailable', LIMITED: 'limited' };
const PERMISSIONS = { IOS: { CAMERA: 'ios.permission.CAMERA' }, ANDROID: { CAMERA: 'android.permission.CAMERA' } };

export { RESULTS, PERMISSIONS };
export const check = () => Promise.resolve(RESULTS.GRANTED);
export const request = () => Promise.resolve(RESULTS.GRANTED);
export const openSettings = () => Promise.resolve();
